import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { Provider } from 'react-redux';
import { HashRouter as Router, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/styles';
import 'shared/design-system/style.scss';

import { ApolloProvider } from 'react-apollo';
import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';
import store from './store';
import DashboardLegacy from './containers/DashboardLegacy';
import DashboardList from './containers/DashboardList';
import FlexibleReport from './containers/FlexibleReport';
import ChartContainer from './containers/ChartContainer';
import ImpactReceiptContainer from './containers/ImpactReceiptContainer';
import { getAuthorizationHeader, getGhostedHeader } from './utils';
import theme from 'shared/containers/AppShell/theme';
import { API_URL } from 'shared/utils/constants';
import { IndicatorProvider } from 'shared/providers/IndicatorProvider';

const httpLink = createHttpLink({
  uri: `${API_URL}/v4`,
});

const authLink = setContext((_, { headers }) => {
  const token = getAuthorizationHeader();
  const tiGhostedUser = getGhostedHeader();
  const updatedHeaders = {
    ...headers,
    'ti-id-token': token,
  };
  if (tiGhostedUser) {
    const parsedTiGhostedUser = tiGhostedUser.replace(/"/gi, '');
    updatedHeaders['ti-ghosted-user'] = parsedTiGhostedUser;
  }
  return {
    headers: updatedHeaders,
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    addTypename: false,
  }),
});

function App() {
  return (
    <ApolloProvider client={client}>
      <ThemeProvider {...{ theme }}>
        <CssBaseline />
        <Provider store={store}>
          <IndicatorProvider>
            <Router>
              <Route path="/flexible-reporting" component={FlexibleReport} />
              <Route
                path="/impact-receipt"
                component={ImpactReceiptContainer}
              />
              <Route path="/chart-container" component={ChartContainer} />
              <Route path="/dashboard-new" component={DashboardList} />
              <Route path="/dashboard-legacy" component={DashboardLegacy} />
            </Router>
          </IndicatorProvider>
        </Provider>
      </ThemeProvider>
    </ApolloProvider>
  );
}

export default App;
